import { Link } from "react-router-dom";

const entries = [
  { to: "/category/movie", label: "电影", en: "Movies", icon: "ri-movie-2-line" },
  { to: "/category/tv", label: "电视剧", en: "TV Series", icon: "ri-tv-2-line" },
  { to: "/category/variety", label: "综艺", en: "Variety", icon: "ri-mic-line" },
  { to: "/category/documentary", label: "纪录片", en: "Documentary", icon: "ri-earth-line" },
];

export default function CategoryQuickLinks() {
  return (
    <section className="grid grid-cols-2 gap-3 md:gap-4 lg:grid-cols-4">
      {entries.map((entry) => (
        <Link
          key={entry.to}
          to={entry.to}
          className="group flex items-center gap-3 rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-accent-300 hover:bg-accent-50"
        >
          <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-md bg-primary-100 text-primary-600 transition-colors group-hover:bg-accent-500 group-hover:text-background-50">
            <i className={`${entry.icon} text-2xl`}></i>
          </span>
          <span className="min-w-0">
            <span className="block text-base font-bold text-foreground-950">{entry.label}</span>
            <span className="block truncate text-xs text-foreground-500">{entry.en}</span>
          </span>
        </Link>
      ))}
    </section>
  );
}